import { render, staticRenderFns } from "./RecommendationsView.vue?vue&type=template&id=2e5b8206&"
import script from "./RecommendationsView.vue?vue&type=script&lang=js&"
export * from "./RecommendationsView.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationsView.vue?vue&type=style&index=0&id=2e5b8206&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports